import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsString,
  IsUUID,
  IsEnum,
  IsOptional,
  MaxLength,
  Matches,
} from 'class-validator'
import { Track } from '../../../enums/track.enum'
import { ProgramCategory } from '../../../enums/program-category.enum'

/**
 * DTO for creating a new program
 */
export class CreateProgramDto {
  @ApiProperty({
    description: 'Unique code for the program',
    example: 'PROG-MATH-6EME',
    maxLength: 128,
  })
  @IsString()
  @MaxLength(128)
  @Matches(/^[A-Z0-9-_]+$/, {
    message:
      'Code must contain only uppercase letters, numbers, hyphens, and underscores',
  })
  code!: string

  @ApiProperty({
    description: 'Program title',
    example: 'Mathématiques 6ème',
    maxLength: 255,
  })
  @IsString()
  @MaxLength(255)
  title!: string

  @ApiPropertyOptional({
    description: 'Program summary',
    example: 'Programme de mathématiques en classe de sixième',
  })
  @IsOptional()
  @IsString()
  summary?: string

  @ApiProperty({
    description: 'Subject UUID',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  @IsUUID()
  subjectId!: string

  @ApiProperty({
    description: 'Level UUID',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  @IsUUID()
  levelId!: string

  @ApiProperty({
    description: 'Educational track',
    enum: Track,
  })
  @IsEnum(Track)
  track!: Track

  @ApiProperty({
    description: 'Program category',
    enum: ProgramCategory,
  })
  @IsEnum(ProgramCategory)
  category!: ProgramCategory
}
